import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tooltip/es/index.js
// module id = ./node_modules/rc-tooltip/es/index.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons